export enum DevicesSortField {
    // The values of this enum correspond to the values the API is expecting.
    CreatedAt = 'created_at',
    LastRunAt = 'last_run_at',
    PassingTests = 'passing_tests',
};